import { createSelector } from "reselect";

import { EntityTypeSupportingGroups } from "@mapmycustomers/shared/types/entity";

import { RootState } from "../rootReducer";

import { stateFieldBaseName } from "./util";

const groupsState = (state: RootState) => state.groups;
export const isAnythingLoading = createSelector(
  groupsState,
  (state) => state.companyGroupsLoading || state.dealGroupsLoading || state.peopleGroupsLoading
);
export const getAnyError = createSelector(
  groupsState,
  (state) => state.companyGroupsError || state.dealGroupsError || state.peopleGroupsError
);

export const getCompanyGroups = createSelector(groupsState, ({ companyGroups }) => companyGroups);
export const getDealGroups = createSelector(groupsState, ({ dealGroups }) => dealGroups);
export const getPeopleGroups = createSelector(groupsState, ({ peopleGroups }) => peopleGroups);
// same as selectors above, but accepts the entityType argument
export const getGroupsForEntity = createSelector(
  [groupsState, (_, entityType: EntityTypeSupportingGroups) => entityType],
  (state, entityType) => state[stateFieldBaseName[entityType]]
);

export const isCreatingGroup = createSelector(
  groupsState,
  ({ createGroupLoading }) => createGroupLoading
);

export const isUpdating = createSelector(
  groupsState,
  ({ updateEntitiesLoading }) => updateEntitiesLoading
);

export const groupsUpdatingInBulk = createSelector(
  groupsState,
  ({ groupsBulkUpdating }) => groupsBulkUpdating
);
